module.exports = __webpack_public_path__ + "img/imac.45fe70c0.png";